module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_suns@2x-4884622a15abf27d27bb89ea1872032d.webp";